import { useState } from 'react'
import { usePartnerApi } from 'hooks/use-partner-api/usePartnerApi'
import { useSubscriptionApi } from 'hooks/use-subscription-api/useSubscriptionApi'

export const useSubscriptionPromoCode = () => {
    const { createPartnerByPromoCode } = usePartnerApi()
    const { verifySubscriptionPromoCode } = useSubscriptionApi()
    const [promoCode, setPromoCode] = useState<string>('')
    const [codeIsVerified, setCodeIsVerified] = useState<boolean>(null)

    return {
        createPartnerByPromoCode,
        verifySubscriptionPromoCode,
        promoCode, 
        setPromoCode,
        codeIsVerified, 
        setCodeIsVerified
    } as const
}